<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('change_theme_color') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-6
      .text-sm.font-semibold.mb-4 {{ $t('preview') }}
      v-card.mx-16.text-center.rounded-lg.px-2.py-2.mb-6(elevation="3")
        .py-6.text-title A001
        v-sheet.rounded-lg.mx-2(:class="colors[selectedColorIndex] | gradientBackground")
          .py-6.text-subtitle Room 1
      
      v-item-group.mb-6(v-model="selectedColorIndex" mandatory)
        .text-center
          template(v-for="(color, i) in colors")
            v-item(v-slot="{active, toggle}")
              v-avatar.mx-1.clickable(:size="active ? 40 : 28" :color="color" @click="toggle" :class="active ? 'color-active' : ''")

    v-divider
    v-card-actions.py-3.px-6
      y-button.px-0(:label="$t('cancel')" @click="showDialog = false" underline)
      v-spacer
      y-button(:label="$t('confirm')" @click="confirm")

</template>

<script>

export default {
  name: 'ThemeColorDialog',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    parentColor: {
      type: String,
    }
  },
  data: () => ({
    selectedColorIndex: null,
    colors: [
      '#333333',
      '#E03E1A',
      '#F79722',
      '#F3C11B',
      '#198F51',
      '#79C96C',
      '#39A2EE',
      '#3B64F8',
      '#8A38F5',
      '#DC64FA',
    ]
  }),
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.parentColor) {
      const index = this.colors.findIndex(c => c === this.parentColor)
      if (index >= 0) {
        this.selectedColorIndex = index
      }
    }
  },
  methods: {
    confirm () {
      this.$emit('onSelectColor', this.colors[this.selectedColorIndex])
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.color-active {
   border: 6px double #fff !important;
}
.text-title {
  font-size: 48px;
  font-weight: 600;
  letter-spacing: -2.2%;
}
.text-subtitle {
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -2.2%;
}
</style>